import { render, staticRenderFns } from "./GuaranteeFaqs.vue?vue&type=template&id=0b426602&scoped=true"
import script from "./GuaranteeFaqs.vue?vue&type=script&lang=js"
export * from "./GuaranteeFaqs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b426602",
  null
  
)

export default component.exports